module.exports = __webpack_public_path__ + "img/tour-57.cd8fef58.png";